import { Button } from '@daily/shared/components/Button';
import { Modal } from '@daily/shared/components/Modal';
import { Text } from '@daily/shared/components/Text';
import { useTheme } from '@daily/shared/contexts/Theme';
import { useMediaQuery } from '@daily/shared/hooks/useMediaQuery';
import { useBreakouts } from 'contexts/BreakoutsProvider';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useBreakoutSessionState } from './hooks/useBreakoutSessionState';

interface Props extends React.ComponentProps<typeof Modal> {}

export const JoinBreakoutModal: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  const { t } = useTranslation();
  const { mediaQueries } = useTheme();
  const { currentBreakoutRoom, invitedBreakoutRoom } =
    useBreakoutSessionState();
  const { declineBreakout, joinBreakout } = useBreakouts();
  const isMobileVP = useMediaQuery(mediaQueries.small);

  const handleClickCancel = () => {
    declineBreakout(true);
    props.onClose();
  };

  const handleClickJoin = () => {
    joinBreakout();
    props.onClose();
  };

  return (
    <Modal
      hideOnBackdropClick={false}
      hideOnEsc={false}
      actions={[
        <Button
          id="breakouts-join-session"
          fullWidth={isMobileVP}
          key="submit"
          onClick={handleClickJoin}
        >
          {t('breakouts.joinModal.join', {
            room: t('breakouts.roomWithName', {
              name: invitedBreakoutRoom?.name,
            }),
          })}
        </Button>,
        <Button
          id="breakouts-cancel-invite"
          fullWidth={isMobileVP}
          key="cancel"
          variant="secondary"
          onClick={handleClickCancel}
        >
          {t('breakouts.joinModal.cancel', {
            room: currentBreakoutRoom?.name
              ? t('breakouts.roomWithName', {
                  name: currentBreakoutRoom?.name,
                })
              : t('breakouts.mainRoom'),
          })}
        </Button>,
      ]}
      title={t('breakouts.joinModal.title')}
      {...props}
    >
      <Text El="label" variant="large">
        {t('breakouts.joinModal.description', {
          room: invitedBreakoutRoom?.name
            ? t('breakouts.roomWithName', {
                name: invitedBreakoutRoom?.name,
              })
            : t('breakouts.mainRoom'),
        })}
      </Text>
    </Modal>
  );
};
